import { paramCase as paramCaseOriginal } from 'change-case'

export const paramCase = paramCaseOriginal
